import { render } from "./DisplayOnlyTheLastLevel.vue?vue&type=template&id=d688d11c"
import script from "./DisplayOnlyTheLastLevel.vue?vue&type=script&lang=ts"
export * from "./DisplayOnlyTheLastLevel.vue?vue&type=script&lang=ts"
script.render = render

export default script